import { render, staticRenderFns } from "./PreviewLink.vue?vue&type=template&id=81ee8fb0&scoped=true&"
import script from "./PreviewLink.vue?vue&type=script&lang=js&"
export * from "./PreviewLink.vue?vue&type=script&lang=js&"
import style0 from "./PreviewLink.vue?vue&type=style&index=0&id=81ee8fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ee8fb0",
  null
  
)

export default component.exports